var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRank12 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 110,
  height: 101,
  viewBox: "0 0 110 101",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_ddd_1_387)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d_1_387)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.924 76H35.732L47.786 17.944H39.094C37.782 21.224 35.896 23.602 33.272 25.078C30.648 26.554 27.45 27.292 23.514 27.292H22.448L20.808 35H32.37L23.924 76ZM80.7064 76L82.5924 66.816H60.6984C61.1904 65.75 62.0104 64.438 63.3224 62.962C64.6344 61.486 66.2744 59.928 68.4064 58.288L76.2784 52.22C78.4104 50.58 80.3784 48.858 82.0184 47.136C83.6584 45.496 85.1344 43.692 86.2824 41.806C87.4304 40.002 88.2504 38.034 88.8244 35.984C89.3164 33.934 89.6444 31.72 89.6444 29.26C89.6444 25.652 88.4144 22.864 86.0364 20.896C83.6584 18.928 79.9684 17.944 75.0484 17.944C68.6524 17.944 63.8144 19.42 60.3704 22.29C56.9264 25.242 54.6304 29.342 53.4824 34.754L52.9904 36.968H64.3064C64.6344 35.492 64.9624 34.016 65.4544 32.622C65.8644 31.31 66.4384 30.08 67.0944 29.014C67.7504 28.03 68.5704 27.21 69.5544 26.554C70.5384 25.98 71.7684 25.652 73.2444 25.652C76.2784 25.652 77.8364 27.21 77.8364 30.162C77.8364 30.654 77.7544 31.064 77.7544 31.474C77.6724 31.966 77.5904 32.376 77.5084 32.868C77.1804 34.426 76.7704 35.738 76.4424 36.886C76.0324 38.034 75.5404 39.018 74.8844 40.002C74.2284 40.986 73.4084 41.97 72.4244 42.954C71.4404 43.938 70.1284 45.004 68.6524 46.152L62.9944 50.58C60.3704 52.548 58.0744 54.516 56.1064 56.484C54.1384 58.452 52.4164 60.42 50.9404 62.388C49.4644 64.438 48.2344 66.57 47.2504 68.784C46.2664 70.998 45.4464 73.376 44.9544 76H80.7064Z",
  fill: "#FAFAFA"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_ddd_1_387",
  x: -11,
  y: 0.94397,
  width: 120.645,
  height: 100.056,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_387"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 9
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_1_387",
  result: "effect2_dropShadow_1_387"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 6
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow_1_387",
  result: "effect3_dropShadow_1_387"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect3_dropShadow_1_387",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_1_387",
  x: 16.8081,
  y: 17.944,
  width: 76.8364,
  height: 66.056,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_387"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1_387",
  result: "shape"
})))));
export default SvgRank12;